module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-setda",
  subdomain: "setda",
};
